import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom'; 
import warning from '../../../images/warning.png';
import profilechange from '../../../images/profilechange.png';
import mypage_arrow from '../../../images/mypage_arrow.png';
import arrow_icon from '../../../images/arrow_icon.png'; 
import appInfoContainer from '../../../auth/appInfoContainer';

export default function MypagePFchangeDtail({
  image,
  profileImg,
  nickname,
  setModalShow,
  setNickname, 
  setPurpose,
  purpose,
  setName,
  email,
  setEmail,
  dataSubmit,
  updateNext,
}) {
  const nicknameChange = (e) => {
    setNickname(e.target.value);
  };
  const purposeChange = (e) => {
    setPurpose(e.target.value);
  };  

  const nicknameVaildate = () => {
    return (
      typeof nickname === 'string' &&
      nickname.length > 1 &&
      nickname.length < 11
    );
  };
  const purposeVaildate = () => {
    return (
      purpose === undefined ||
      purpose === null ||
      (typeof purpose === 'string' && purpose.length < 21)
    );
  };

  const pwpage = () => {
    updateNext(2);
  };
 
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      <TopInner style={{ borderBottom: 'solid calc(100vw*(1/375)) #d5d5d5' }}>
        <Back onClick={goBack}>
          <img src={arrow_icon}></img>
        </Back>
        <Title>프로필 수정</Title>

        <Finish onClick={dataSubmit}> 완료 </Finish>
      </TopInner>
      <Profileimg>
        <a>
          <ProfileBox>
            <PfimgArea
              onClick={() => {
                setModalShow(true);
              }}
            >
              <Pfimg>
                <ProfileImgTag
                  src={
                    image
                      ? image
                      : appInfoContainer.imagePath +
                        '/user_profile_img/' +
                        profileImg
                  }
                />
              </Pfimg>
              <Pfinput type="file" id="pf_file"></Pfinput>
              <Pflaber>
                <img src={profilechange}></img>
              </Pflaber>
            </PfimgArea>
          </ProfileBox>
        </a>
      </Profileimg>

      <ProfileBox>
        <Listboxinner>
          <Listbox>
            <ListTit>닉네임</ListTit>
            <Listinput
              type="text"
              value={nickname}
              onChange={nicknameChange}
              color={
                nickname === null ||
                nickname === undefined ||
                nickname.length == 0 ||
                nicknameVaildate()
                  ? '#d5d5d5'
                  : '#de0000'
              }
              maxLength={11}
              minLength={2}
            />
          </Listbox>
          {/* <Alert>
                        <Alerticon><img src={warning}></img></Alerticon>
                        이미 존재하는 닉네임 입니다</Alert> */}
          <Alert
            display={
              nickname === null ||
              nickname === undefined ||
              nickname.length == 0 ||
              nicknameVaildate()
                ? 'none'
                : 'flex'
            }
          >
            <Alerticon>
              <img src={warning}></img>
            </Alerticon>
            닉네임은 영문/한글/숫자 2-10글자로 설정해 주세요
          </Alert>

          <Listbox>
            <ListTit>자기소개</ListTit>
            <Listinput
              type="text"
              value={purpose}
              placeholder="나만의 목표를 설정해 보세요!"
              color={'#c6c6c6'}
              onChange={purposeChange}
              display={purposeVaildate() ? 'none' : 'flex'}
              maxLength={21}
              minLength={2}
            />
          </Listbox>
          <Alert display={purposeVaildate() ? 'none' : 'flex'}>
            <Alerticon>
              <img src={warning}></img>
            </Alerticon>
            달성목표는 20글자로 이내로 설정해 주세요
          </Alert>
          {/* <Listbox >
                        <ListTit>이름</ListTit>
                        <Listinput type="text" placeholder="송유진" color={"#989898"} onChange={nameChange}></Listinput>
                    </Listbox> */}
          <Listbox>
            <ListTit>이메일</ListTit>
            <Emailtext>{email}</Emailtext>
            {/* <Listinput type="email" value={email} placeholder="sophie.unitmi@gmail.com" color={"#989898"} onChange={emailChange}></Listinput> */}
          </Listbox>
        </Listboxinner>
      </ProfileBox>

      <ProfileBox>
        <Listboxinner>
          <ListboxPW onClick={pwpage}>
            <ListTit>비밀번호</ListTit>
            <Arrowright>
              <img src={mypage_arrow}></img>
            </Arrowright>
          </ListboxPW>
        </Listboxinner>
      </ProfileBox>
    </>
  );
}

const ProfileImgTag = styled.img`
  min-height: 100%;
  max-height: 100%;
  min-width: 100%;
  max-width: 100%;
  object-fit: cover;
`;

const Profileimg = styled.div`
  padding: calc(100vw * (32 / 375)) 0 calc(100vw * (45 / 375)) 0;
  border-bottom: calc(100vw * (9 / 375)) solid #f7f7f7;
  text-align: center;
`;
const ProfileBox = styled.div`
  // width: calc(100vw*(224/375));
  // margin : 0 auto;
  text-align: center;
`;
const Pfimg = styled.p`
  display: block;
  width: calc(100vw * (116 / 375));
  height: calc(100vw * (116 / 375));
  border-radius: 50%;
  overflow: hidden;
  border: calc(100vw * (1 / 375)) solid #c6c6c6;
`;
const PfimgArea = styled.a`
  position: relative;
  display: inline-block;
  margin-bottom: calc(100vw * (5 / 375));
`;
const Pfinput = styled.input`
  display: none;
`;
const Pflaber = styled.label`
  display: block;
  width: calc(100vw * (33 / 375));
  height: calc(100vw * (34 / 375));
  position: absolute;
  bottom: 0;
  right: 0;
`;

// const ProfileBox = styled.div`

// `
const Listboxinner = styled.ul`
  width: 100%;
`;
const Listbox = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  height: calc(100vw * (55 / 375));
  border-bottom: solid calc(100vw * (1 / 375)) #eaeaea;
  padding: 0 calc(100vw * (15 / 375));
`;
const ListTit = styled.span`
  display: block;
  width: calc(100vw * (74 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  text-align: left;
`;
const Listinput = styled.input`
  display: block;
  width: calc(100vw * (252 / 375));
  font-size: calc(100vw * (14 / 375));
  height: calc(100vw * (41 / 375));
  padding: 0 calc(100vw * (17 / 375));
  border: solid calc(100vw * (1 / 375)) ${({ color }) => color};
  border-radius: calc(100vw * (5 / 375));

  &::placeholder {
    color: #c6c6c6;
  }
  &:focus {
    border-radius: calc(100vw * (5 / 375));
    border: solid calc(100vw * (1 / 375)) #ffcf19;
  }
`;
const Emailtext = styled.span`
  display: block;
  width: calc(100vw * (252 / 375));
  font-size: calc(100vw * (14 / 375));
  height: calc(100vw * (41 / 375));
  padding: 0 calc(100vw * (17 / 375));
  text-align: left;
  line-height: calc(100vw * (39 / 375));
`;
const ListboxPW = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  height: calc(100vw * (55 / 375));
  border-bottom: solid calc(100vw * (1 / 375)) #eaeaea;
  padding: 0 calc(100vw * (15 / 375));
  justify-content: space-between;
`;
const Arrowright = styled.span`
  display: block;
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (13 / 375));
  object-fit: contain;
  // margin-left : calc(100vw*(10.7/375));
`;

// 탑
const TopInner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 200;
  width: 100%;
  height: calc(100vw * (51 / 375));
  display: felx;
  align-items: center;
  padding: 0 calc(100vw * (17 / 375));
`;
const Title = styled.h1`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: 0.32px;
  // margin-left: calc(100vw*(131.2/375));
`;

const Back = styled.a`
  display: block;
  width: calc(100vw * (9.8 / 375));
  height: calc(100vw * (16 / 375));
`;
const Finish = styled.a`
  display: block;
  font-size: calc(100vw * (16 / 375));
  font-weight: 600;
  line-height: 2.83;
  color: #ffc036;
  margin-left: calc(100vw * (-38 / 375));
`;

const Alert = styled.span`
  display: flex;
  display: ${({ display }) => display};
  align-items: center;
  font-size: calc(100vw * (10 / 375));
  color: #de0000;
  margin-top: calc(100vh * (3 / 812));
  padding-left: calc(100vw * (90 / 375));
`;
const Alerticon = styled.em`
  display: inline-block;
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (9 / 375));
  margin-right: calc(100vw * (2.2 / 375));
`;
